/**
 * Favorite feature data models and interfaces.
 */

/** A single slot in the Favorites table (UI row) */
export interface FavoriteSlot {
  slno: string;
  UIName: string | null;
  Filename: string | null;
  Name: string | null; // raw blob content
  shareableLink: string | null;
}

/** Sections index map for legacy "$" separated format */
export enum LegacySectionIndex {
  SlotNumber = 0,
  FinishedOil = 1,
  Package1Pred1 = 2,
  Package1Pred2 = 3,
  Package2Pred1 = 4,
  Package2Pred2 = 5,
  WtPer11 = 6,
  WtPer12 = 7,
  WtPer21 = 8,
  WtPer22 = 9,
  DilPer11 = 10,
  DilPer12 = 11,
  DilPer21 = 12,
  DilPer22 = 13,
  ModInpDi = 14,
  ModInpVm = 15,
  ModInpPpd = 16,
  ModInpBo = 17,
  ModInpColVm = 18,
  ModInpColBo = 19,
  ModInpColDi = 20,
  ModInpDi2 = 21,
  ModInpVm2 = 22,
  ModInpPpd2 = 23,
  ModInpBo2 = 24,
  ModInpColVm2 = 25,
  ModInpColBo2 = 26,
  ModInpColDi2 = 27,
  ShareableLinks = 28,
}

/** Parsed blend state from a favorite (common structure for both formats) */
export interface FavoriteBlendState {
  finishedOilData: Record<string, string>[];
  package1Pred1: Record<string, string>[];
  package1Pred2: Record<string, string>[];
  package2Pred1: Record<string, string>[];
  package2Pred2: Record<string, string>[];
  wtPer11: string | null;
  wtPer12: string | null;
  wtPer21: string | null;
  wtPer22: string | null;
  dilPer11: string | null;
  dilPer12: string | null;
  dilPer21: string | null;
  dilPer22: string | null;
  modInpDi: Record<string, string>[];
  modInpVm: Record<string, string>[];
  modInpPpd: Record<string, string>[];
  modInpBo: Record<string, string>[];
  modInpColVm: Record<string, string>[];
  modInpColBo: Record<string, string>[];
  modInpColDi: Record<string, string>[];
  modInpDi2: Record<string, string>[];
  modInpVm2: Record<string, string>[];
  modInpPpd2: Record<string, string>[];
  modInpBo2: Record<string, string>[];
  modInpColVm2: Record<string, string>[];
  modInpColBo2: Record<string, string>[];
  modInpColDi2: Record<string, string>[];
  shareableLink: string | null;
}

/** JSON v2 payload stored in blob */
export interface FavoritePayloadV2 {
  version: 2;
  slotNumber: string;
  blendState: FavoriteBlendState;
}

/** A row accepted by the React-compatible V1 Object.entries serializer. */
export type FavoriteV1Row = Record<string, unknown>;

/** Total number of favorite slots */
export const FAVORITE_SLOT_COUNT = 100;

/** Creates an empty array of FavoriteSlots */
export function createEmptySlots(): FavoriteSlot[] {
  return Array.from({ length: FAVORITE_SLOT_COUNT }, (_, i) => ({
    slno: String(i + 1),
    UIName: null,
    Filename: null,
    Name: null,
    shareableLink: null,
  }));
}
